import { Header, Input, Icon } from "semantic-ui-react";
import { useEffect, useState } from "react";

import Pagination from "../../../components/Pagination/Pagination.js";
import { TableComponent } from "../../../components/Table/table.js";
import BackButton from "../../../components/BackButton/BackButton.js";
import ActionDropdown from "../../../components/ActionDropdown/ActionDropdown.js";
import Loading from "../../../components/Loading/Loading.js";
import { api } from "../../../api/api.js";
import moment from "moment";
import { assign_batch_url } from "../../../api/urls.js";
import axios from "axios";
import unknownError from "../../../utils/unknownError.js";
import { modules, perms } from "../../../api/codes.js";
import { useModal } from "../../../components/Modaler";
import { useToast } from "../../../components/Toast";
import { ProtectedElement } from "../../../components/ProtectedElement/ProtectedElement.js";
import { TextChip } from "../../../components/TextChip/TextChip.js";
import { DashboardImage } from "../../../components/DashboardImage/DashboardImage.js";
import { Link } from "react-router-dom/cjs/react-router-dom.min.js";

const title = "Delivery Settlements";
const apiUrl = assign_batch_url;
const module = modules.DeliverySettlement;
const searchFeild = "batch_code";
const headers = [
  "Delivery personnel",
  "Batch Code",
  "Delivery Colletions",
  "Total Earnings",
  "Payment status",
  "Created at",
  "Action",
];

const bodyMap = (d, refetch, modaler) => {
  return [
    <div
      style={{
        display: "flex",
        gap: "10px",
        justifyContent: "flex-start",
        alignItems: "center",
        width: "100%",
      }}
    >
      <DashboardImage src={d.delvboyimage} height="40px" width="40px" circle />
      <div>{d.delvboyname}</div>
    </div>,
    d.batch_code,
    `₹ ${d.order_collection}`,
    `₹ ${d.batch_earning}`,
    <TextChip
      color={d.is_closed ? "#03A326" : "#b91c1c"}
      text={d.is_closed ? "Settled" : "Unsettled"}
    />,
    moment(d.created_at).format("DD-MM-YYYY"),
    <ActionDropdown
      options={(closer) => {
        return (
          <>
            <Link to={`/logistics/delivery_settlement/view/${d.id}`}>
              <div
                className="option"
                onClick={() => {
                  closer();
                }}
              >
                <div className="green-title">View Details</div>
              </div>
            </Link>
            <ProtectedElement module={module} perm={perms.edit}>
              <div
                className="option"
                onClick={() => {
                  modaler.opener(
                    <MarkAsSettled
                      d={d}
                      refetch={refetch}
                      closer={modaler.closer}
                    />,
                    false
                  );
                }}
              >
                <div className="purple-title">
                  {d.is_closed ? "Mark as Unsettled" : "Mark as Settled"}
                </div>
              </div>
            </ProtectedElement>
          </>
        );
      }}
    />,
  ];
};

function MarkAsSettled({ d, refetch, closer }) {
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  return (
    <div style={{ padding: "20px" }}>
      <div style={{ fontSize: "22px", fontWeight: "500" }}>Are you sure?</div>
      <div style={{ padding: "15px" }} />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "10px",
        }}
      >
        <button
          className="btn-red"
          onClick={() => {
            closer();
          }}
        >
          No
        </button>
        <button
          className="btn"
          disabled={loading}
          onClick={async () => {
            setLoading(true);
            try {
              await api.patch(apiUrl + d.id + "/", {
                is_closed: !d.is_closed,
              });
              closer();
              refetch();
              toast.open("Status changed successfully", "success");
            } catch (e) {
              if (e?.response?.status === 400 && e?.response?.data?.data) {
                toast.open(e?.response?.data.data, "error");
              } else {
                unknownError(e);
              }
            }
            setLoading(false);
          }}
        >
          Yes
        </button>
      </div>
    </div>
  );
}

const DeliverySettlement = () => {
  const modaler = useModal();
  const [data, setData] = useState();
  const [search, setSearch] = useState("");
  const [refetcher, setRefetcher] = useState(false);

  const [limit, setLimit] = useState(25);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState();

  useEffect(() => {
    const source = axios.CancelToken.source();
    const getData = async () => {
      setData();
      try {
        const res = await api.get(
          apiUrl + "?limit=" + limit + "&offset=" + offset,
          {
            cancelToken: source.token,
            headers: {
              module: module,
            },
          }
        );
        setData(res.data);
        setCount(res.data.count);
      } catch (err) {
        unknownError(err);
      }
    };
    getData();
    return () => {
      source.cancel();
    };
  }, [refetcher, limit, offset]);

  const refetch = () => {
    setRefetcher((v) => !v);
  };

  return (
    <>
      <BackButton />
      <div id="heading">
        <Header>{title}</Header>
        <div className="right">
          <Input
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            icon={<Icon name="search" link id="search-icon" />}
          />
        </div>
      </div>
      {data ? (
        <>
          <TableComponent
            headers={headers}
            body={
              data.results
                ? data.results
                    .filter((d) =>
                      d[searchFeild]
                        .toLowerCase()
                        .includes(search.toLowerCase())
                    )
                    .map((d) => {
                      return bodyMap(d, refetch, modaler);
                    })
                : []
            }
            showbottom={false}
            disableHeaderPopup
          />
        </>
      ) : (
        <Loading />
      )}
      {count ? (
        <Pagination count={count} setLimit={setLimit} setOffset={setOffset} />
      ) : null}
    </>
  );
};

export default DeliverySettlement;
